export const convertDate = (
  originalDateValue: string,
  format: string = "YYYY-MM-DD"
) => {
  const originalDate = new Date(originalDateValue);

  // // Extract year, month, and day components
  // const year = originalDate.getFullYear() % 100; // Get the last two digits of the year
  // const month = originalDate.getMonth() + 1; // Month is zero-based, so add 1
  // const day = originalDate.getDate();

  // // Format the components in the desired format
  // const formattedDate = `${day.toString().padStart(2, "0")}/${month
  //   .toString()
  //   .padStart(2, "0")}/${year.toString().padStart(2, "0")}`;
  // return formattedDate;
  const yearFull = originalDate.getFullYear().toString();
  const yearShort = yearFull.substr(-2);
  const month = (originalDate.getMonth() + 1).toString().padStart(2, "0");
  const day = originalDate.getDate().toString().padStart(2, "0");

  const replacements: { [key: string]: string } = {
    YYYY: yearFull,
    YY: yearShort,
    MM: month,
    DD: day,
  };

  return format.replace(/YYYY|YY|MM|DD/g, (match) => replacements[match]);
};

export const convertDateAndTime = (
  originalDateValue: string,
  isHour12: boolean,
  utcTime: number
) => {
  // Treat input as UTC+0 and adjust to the specified UTC offset
  const originalDate = new Date(originalDateValue);
  const utcTimestamp = originalDate.getTime();
  const adjustedDate = new Date(utcTimestamp + utcTime * 60 * 60 * 1000);

  return `${adjustedDate
    .toLocaleString("en-GB", {
      timeZone: "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: isHour12,
    })
    .replace(",", "")}`;
};

export function getDateFromMonthsAgo(
  monthsAgo: number,
  fromDate: Date | string = new Date()
): Date {
  // Validate input
  if (monthsAgo < 0) {
    throw new Error("monthsAgo must be a non-negative number");
  }

  // Parse input date
  const inputDate =
    typeof fromDate === "string" ? new Date(fromDate) : fromDate;

  if (isNaN(inputDate.getTime())) {
    throw new Error("Invalid date provided");
  }

  // Store the original day to handle month-end edge cases
  const originalDay = inputDate.getDate();

  // Create new date and subtract months
  const resultDate = new Date(inputDate);
  resultDate.setMonth(resultDate.getMonth() - monthsAgo);

  // Handle month-end overflow
  // If we wanted day 31 but the target month only has 28-30 days,
  // JavaScript automatically overflows to the next month
  // We need to roll back to the last day of the intended month
  if (resultDate.getDate() !== originalDay) {
    // Set to day 0 of the next month (which gives us the last day of the current month)
    resultDate.setDate(0);
  }

  return resultDate;
}
